var React = require('react');

function DotCircleRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"}));
}

DotCircleRegular.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"far","data-icon":"dot-circle","className":"svg-inline--fa fa-dot-circle fa-w-16","role":"img","viewBox":"0 0 512 512"};

module.exports = DotCircleRegular;

DotCircleRegular.default = DotCircleRegular;
